import { makeAutoObservable } from 'mobx';
import { BUILD_NUMBER } from '../constant/config';
import { CommandCentreVenue } from '../state/UserState';

class UserVenuesStore {
  MIGRATION_KEY = 'userVenueMigrationKey';

  STORAGE_KEY = 'userVenues';

  SELECTED_KEY = 'selectedVenueId';

  constructor() {
    makeAutoObservable(this);
  }
  migrateStore() {
    let needsMigration =
      localStorage.getItem(this.MIGRATION_KEY) !== BUILD_NUMBER;

    console.log('UserVenuesStore needs migration ? ' + needsMigration);

    if (needsMigration) {
      this.clearStore();
      localStorage.setItem(this.MIGRATION_KEY, BUILD_NUMBER);
    }
  }

  getVenues(): CommandCentreVenue[] | undefined {
    let venues = localStorage.getItem(this.STORAGE_KEY);

    if (venues == null) return undefined;

    return JSON.parse(venues);
  }

  storeVenues(venues: CommandCentreVenue[]) {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(venues));
  }

  /**
   * The venue picked most recently in this browser. Kept in localStorage rather than
   * sessionStorage because a newly opened tab starts with empty sessionStorage.
   */
  getSelectedVenueId(): number | null {
    try {
      const raw = localStorage.getItem(this.SELECTED_KEY);
      const id = raw ? Number(raw) : NaN;
      return Number.isInteger(id) ? id : null;
    } catch {
      return null;
    }
  }

  storeSelectedVenueId(venueId: number) {
    try {
      localStorage.setItem(this.SELECTED_KEY, String(venueId));
    } catch {
      // Storage unavailable (private mode, quota): the venue simply isn't remembered.
    }
  }

  clearStore() {
    localStorage.removeItem(this.STORAGE_KEY);
    localStorage.removeItem(this.SELECTED_KEY);
  }
}

export default new UserVenuesStore();
